const ChatActionPanel = ({
  children,
  gap = '10px',
  justifyContent = 'center',
  style = {},
}) => {
  return (
    <div className='chat-inputbar'>
      <div className='chat-input-inner'>
        <div
          style={{
            display: 'flex',
            width: '100%',
            gap,
            justifyContent,
            ...style,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default ChatActionPanel